import { render } from "./CardSetup.vue?vue&type=template&id=a7f19110"
import script from "./CardSetup.vue?vue&type=script&lang=js"
export * from "./CardSetup.vue?vue&type=script&lang=js"

import "./CardSetup.vue?vue&type=style&index=0&id=a7f19110&lang=scss"
script.render = render

export default script